import { createSelector } from '@reduxjs/toolkit';
import { getState, getCommercetoolsProjectKey, getCurrentCountryRoot, getCurrentLanguageRoot, getCommon, } from '@yme/selectors/common';
import { getPayment } from '../redux/selectors';
const getCart = createSelector(getState, (state) => state.cart);
export const getRootPath = createSelector(getState, (state) => state.common.languageRootPath);
const getLanguage = createSelector(getCommon, (common) => common.language);
export const getPaymentData = createSelector([
    getPayment,
    getCart,
    getCurrentLanguageRoot,
    getCurrentCountryRoot,
    getRootPath,
    getCommercetoolsProjectKey,
    getLanguage,
], (payment, cart, currentLanguage, currentCountry, languageRootPath, currentProjectKey, language) => ({
    payment,
    cart,
    currentLanguage,
    currentCountry,
    languageRootPath,
    currentProjectKey,
    language,
}));
